import { computed } from "vue";
import { useStore } from "vuex";
import { vuexName, MODULES } from "@/store/utils";
import { ExposureItemMedia } from "@/store/lesson/state";

export const useLessonStore = () => {
  const { getters, commit } = useStore();
  return {
    visibleTargetTags: computed<string[]>(() => getters[vuexName(MODULES.LESSON.GETTERS.GET_VISIBLE_TARGET_TAGS)]),
    currentSelectedSlide: computed<ExposureItemMedia | undefined>(() => getters[vuexName(MODULES.LESSON.GETTERS.GET_CURRENT_EXPOSURE_ITEM_MEDIA)]),
    setVisibleTargetTagsToEmpty: () => commit(vuexName(MODULES.LESSON.COMMITS.SET_VISIBLE_TARGET_TAGS), []),
  };
};
